// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// 本地启动：npm run dev  启动
// 编译打包：npm run build

// import Vue from 'vue'
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()

import router from './router'
import store from './store';
import App from './App'
import {DETAIL as API} from "./assets/api";
import {commonUtil as commonUtils} from './assets/common'
import { Tabbar, TabbarItem } from 'vant';
import {ApiUrl as ApiUrl1} from './assets/common'//引用文件
import axios from './assets/ajax'
import { Lazyload, Field, Button,Row,Col,Popup,Loading, Toast, Calendar} from 'vant';
import qs from "qs";
import $ from 'jquery';

// options 为可选参数，无则不传
Vue.use(Lazyload);
Vue.use(Calendar);
Vue.use(Tabbar).use(TabbarItem).use(Field).use(Button).use(Row).use(Col).use(Popup).use(Loading);
Vue.config.productionTip = false
Vue.prototype.qs = qs;
Vue.prototype.commonUtil=commonUtils;
Vue.prototype.url = ApiUrl1//挂载到Vue实例上面
Vue.prototype.$http = axios
Vue.prototype.Toast = Toast

// import VConsole from 'vconsole';
// const vConsole = new VConsole();

// import BaiduMap from 'vue-baidu-map'
// Vue.use(BaiduMap, {
//     // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
//     ak: 'MZxdUgouVKXjGfDSlByLdKTQ1GNkUoDm'
//   })

// import FastClick from 'fastclick';
// if ('addEventListener' in document) {
//   document.addEventListener('DOMContentLoaded', function() {
//       FastClick.attach(document.body);
//   }, false)};

router.beforeEach((to, from, next) => {
    /* 页面title */
    if (to.meta.title) {
        document.title = to.name=='invoiceHzhospital'&&sessionStorage.getItem("commid")=='5CD00015'?'湖州市中心医院停车费自助开票':to.meta.title
    }
    if (to.matched.length ===0) {
        from.name ? next({ name:from.name }) : next('/index');
    }
    //已登录进入登录页则跳转到首页
    if(to.name == "login"){
        if (commonUtils.isLogin()) {//已登录
            next({
                path: '/my',
                query:to.query
            })
        }else{
            next()
        }
    }
    /* 判断该路由是否需要登录权限 */
    if (to.matched.some(record => record.meta.requireAuth)) {
        //是否登录
        if (commonUtils.isLogin()) {//已登录
            next()
        }else{//未登录
            sessionStorage.setItem("routerName",to.name);
            
            // 用户主动退出，不自动登录
            let isUserLogOut = commonUtils.getCookie('isUserLogOut')
            if(isUserLogOut){
                next({
                    path: '/login',
                    query:to.query
                })
            }else{
                let loginStatus = store.state.loginStatus;
                if(!loginStatus){
                    let browserType = commonUtils.browserType();
                    let o = ''
                    if(browserType == 'wx'){
                        o = commonUtils.originalId();
                    }else if(browserType == 'al'){
                        o = commonUtils.aliuserid();
                    }
                    if(browserType == 'other') {Toast('请用微信或者支付宝打开!');return}
                    $.ajax({
                        url: API.LOGIN,
                        type:'POST', 
                        async:false, //true或false,是否异步
                        data:{'originalId': o, 'browserType': browserType},
                        timeout:5000, //超时时间
                        dataType:'json', //返回的数据格式
                        success:function(res){
                           if (res.code == 0) {
                                commonUtils.delCookie('isUserLogOut')
                                const expriyTimeStamp = new Date().getTime()+store.state.indate*24*60*60*1000;
                                store.commit('setExpriyTimeStamp',expriyTimeStamp);
                                if (res.data.length) { // 保存车辆信息
                                    commonUtils.updateUserInfo(res.data[0].phonenumber);//登录成功保存用户信息
                                    let cars = [];
                                    if(res.data[0].cars) cars = res.data[0].cars;
                                    store.commit('getBindCars',cars);
                                }
                                let routerName = sessionStorage.getItem("routerName") || 'my';
                                router.replace({name:routerName});
                            } else {
                                next({
                                    path: '/login',
                                    query:to.query
                                })
                            }
                        },
                        error:function(textStatus){
                            alert("自动登录失败");
                            console.log('请求失败'+textStatus);
                        }
                     
                    })
                }else{
                    next({
                        path: '/login',
                        query:to.query
                    })
                }
            }

        }
    }
    let os = commonUtils.getUrlKey("os");//来源 公众号或非公众号
    if(os){
        sessionStorage.setItem("os",os);
    }
    if(to.name=="indetail" || to.name=="inoutdetail"){
        var carNumUrl=commonUtils.getUrlKey("carNum");
        var carPic=commonUtils.getUrlKey("carPic");
        var bindUrl=commonUtils.getUrlKey("bindUrl");
        if(!commonUtils.isEmpty(carNumUrl)){
            sessionStorage.setItem("carNum",carNumUrl);
            sessionStorage.setItem("carPic",carPic);
            sessionStorage.setItem("bindUrl",bindUrl);
        }
    }
    
    if(to.name =="invoiceHzhospital"){
        var appid=commonUtils.getUrlKey("appid");
        var parkingno=commonUtils.getUrlKey("parkingno");
        var commid=commonUtils.getUrlKey("commid");
        if(appid){
            sessionStorage.setItem("appid", appid);
            sessionStorage.setItem("parkingno", parkingno);
            sessionStorage.setItem("commid", commid);
        }
    }
    if(to.name !=="informdetail" && to.name !== 'invoice'){
        commonUtils.init()
    }
    next();
})
// 将用户名存进cookie，第三个参数60为秒，意味着一分钟后cookie自动消失。一天为 86400 s
// 	this.$cookieStore.setCookie( 'username' ,this.username,60);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js